import * as React from "react"
import { Box } from "@mui/material"
import { translateCountryName } from "@ui-seeker/utils"

import { LabelCountry } from "@components"


export default function retailerInfoColumn() {
    return [{
        name: "country", label: "Country",
        options: {
            display: "excluded",
            customBodyRowRender: value => translateCountryName(value)
        }
    }, {
        name: "retailer", label: "Retailer",
        options: { display: "excluded" }
    }, {
        name: "retailer", label: "Retailer Info",
        options: {
            filter: false,
            customBodyRowRenderLite: (value, { country, siteURL }) => {
                return <Box display="flex" flexDirection="column">
                    <LabelCountry country={country} label={value} siteURL={siteURL} />
                </Box>
            }
        }
    }]
}